
import { useState, ReactNode } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";
import { PhotoUploadForm } from "../forms/PhotoUploadForm";
import { uploadPhotoToGallery } from "../utils/photoUploadUtils";

interface PhotoUploadDialogProps {
  userId?: string;
  onPhotoUploaded: () => void;
  trigger: ReactNode;
  title?: string;
  initialCategory?: string;
}

export function PhotoUploadDialog({
  userId,
  onPhotoUploaded,
  trigger,
  title,
  initialCategory = "recent"
}: PhotoUploadDialogProps) {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [photoTitle, setPhotoTitle] = useState("");
  const [photoCategory, setPhotoCategory] = useState(initialCategory);
  const { language } = useLanguage();

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || e.target.files.length === 0 || !userId) {
      return;
    }

    const file = e.target.files[0];
    setIsUploading(true);

    await uploadPhotoToGallery({
      file,
      userId,
      photoTitle,
      photoCategory,
      language,
      onSuccess: () => {
        setPhotoTitle("");
        setUploadDialogOpen(false);
        onPhotoUploaded();
      },
      onError: () => {},
      onFinally: () => setIsUploading(false)
    });
  };

  return (
    <Dialog open={uploadDialogOpen} onOpenChange={setUploadDialogOpen}>
      <DialogTrigger asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {title || t('gallery.uploadNewPhoto', language)}
          </DialogTitle>
        </DialogHeader>
        <PhotoUploadForm
          photoTitle={photoTitle}
          setPhotoTitle={setPhotoTitle}
          photoCategory={photoCategory}
          setPhotoCategory={setPhotoCategory}
          onFileSelect={handleFileUpload}
          isUploading={isUploading}
        />
      </DialogContent>
    </Dialog>
  );
}
